// frontend/src/pages/reports/usePromotionResult.js
//
// What the merchant hears after "Create promotion" on the Dead stock and
// Excess stock reports. The server answers `created: false` when every
// selected item is already promoted (api/services/promotion_engine.py).

import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { showToast } from '../../components/common/appToastBus';
import { useTabs } from '../../tabs/useTabs';

/**
 * @param {'deadStock' | 'excess'} report  the report's i18n namespace
 * @returns {(result: object) => void}  toasts a create-promotion response
 */
export function usePromotionResult(report) {
  const { t } = useTranslation();
  const { openTab } = useTabs();
  return useCallback((result) => {
    const skipped = result.skipped_already_promoted.length;
    if (!result.created) {
      showToast(t(`reports.${report}.actions.allSkipped`, { count: skipped }), 'warning');
      return;
    }
    showToast(
      [
        t(`reports.${report}.actions.createPromoSuccess`, { count: result.added_items, name: result.promotion_name }),
        skipped > 0 && t(`reports.${report}.actions.skippedAlreadyPromoted`, { count: skipped }),
      ].filter(Boolean).join(' '),
      'success',
      { label: t(`reports.${report}.actions.viewPromotions`), onClick: () => openTab('/promotions') },
    );
  }, [report, t, openTab]);
}
